// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-tabs {
  border-bottom: 0;
  margin-bottom: 3px;
  position: relative;
  z-index: 1;
}
.nav-tabs :hover {
  cursor: pointer;
}
.nav-tabs>li {
  font-size: 14px;
  font-weight: normal;
  height: 40px;
  line-height: 40px;
  margin-bottom: 0;
}
.nav-tabs>li>button {
  display: block;
  width: 100%;
  line-height: inherit;
  margin: 0;
  height: inherit;
  padding: 0 10px 0 10px;
  outline: none;
}
.nav-tabs>li>button:after {
  background-color: transparent;
  bottom: -3px;
  content: ' ';
  display: block;
  height: 3px;
  width: 100%;
}
.nav-tabs>li>button,
.nav-tabs>li.active>button,
.nav-tabs>li>button:hover,
.nav-tabs>li.active>button:hover,
.nav-tabs>li>button:active,
.nav-tabs>li.active>button:active,
.nav-tabs>li>button:focus,
.nav-tabs>li.active>button:focus {
  color: var(--active-color);
  background-color: transparent;
  border: 0;
}
.nav-tabs>li.active>button {
  font-weight: bold;
}
.nav-tabs>li.active>button:after {
  background-color: var(--active-color);
}
.nav {
  padding-left: 0;
  list-style: none;
}
.nav > li {
  position: relative;
  display: block;
}
.nav > li {
  float: left;
  margin-bottom: -1px;
}
.TabComponents .TabComponents_tabHeader {
  display: flex;
  flex-direction: column;
  margin-left: -20px;
  margin-right: -20px;
}
.TabComponents .TabComponents_tabHeader_selector {
  border-bottom: 3px solid #000;
  padding: 0 25px;
}
.TabComponents .TabComponents_content {
  min-height: 450px;
  display: none;
  padding: 0 15px;
}
.TabComponents .TabComponents_content.active {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/tabComponents/navbar.styl","webpack://./../../ui/src/components/tabComponents/TabComponents.styl"],"names":[],"mappings":"AAAA;EACE,gBAAe;EACf,kBAAe;EACf,kBAAU;EACV,UAAS;ACCX;ADCE;EACE,eAAQ;ACCZ;ADCE;EACE,eAAW;EACX,mBAAa;EACb,YAAQ;EACR,iBAAa;EACb,gBAAe;ACCnB;ADCI;EACE,cAAS;EACT,WAAO;EACP,oBAAa;EACb,SAAQ;EACR,eAAQ;EACR,sBAAS;EACT,aAAS;ACCf;ADCM;EACE,6BAAkB;EAClB,YAAQ;EACR,YAAS;EACT,cAAS;EACT,WAAQ;EAER,WAAO;ACAf;ADGM;;;;;;;;EACE,0BAAO;EACP,6BAAkB;EAClB,SAAQ;ACMhB;ADJI;EACE,iBAAa;ACMnB;ADJM;EACE,qCAAkB;ACM1B;ADJA;EACE,eAAc;EACd,gBAAY;ACMd;ADJE;EACE,kBAAU;EACV,cAAS;ACMb;ADJE;EACE,WAAO;EACP,mBAAe;ACMnB;AA3DE;EACE,aAAS;EACT,sBAAgB;EAChB,kBAAa;EACb,mBAAc;AA6DlB;AA3DE;EACI,6BAAe;EACf,eAAS;AA6Df;AA3DE;EACE,iBAAY;EACZ,aAAS;EACT,eAAS;AA6Db;AA3DI;EACE,aAAS;EACT,sBAAgB;EAChB,8BAAiB;AA6DvB","sourcesContent":[".nav-tabs\n  border-bottom: 0\n  margin-bottom: 3px\n  position: relative\n  z-index: 1\n\n  :hover\n    cursor: pointer\n\n  &>li\n    font-size: 14px\n    font-weight: normal\n    height: 40px\n    line-height: 40px\n    margin-bottom: 0\n\n    &>button\n      display: block\n      width: 100%\n      line-height: inherit\n      margin: 0\n      height: inherit\n      padding: 0 10px 0 10px\n      outline: none\n\n      &:after\n        background-color: transparent\n        bottom: -3px\n        content: ' '\n        display: block\n        height: 3px\n        transition(background-color 0.3s ease)\n        width: 100%\n\n    &>button, &.active>button\n      &, &:hover, &:active, &:focus\n        color: var(--active-color)\n        background-color: transparent\n        border: 0\n\n    &.active>button\n      font-weight: bold\n\n      &:after\n        background-color: var(--active-color)\n\n.nav\n  padding-left: 0;\n  list-style: none;\n\n  > li\n    position: relative;\n    display: block;\n\n  > li\n    float: left;\n    margin-bottom: -1px;\n","@import './navbar.styl'\n\n.TabComponents\n  .TabComponents_tabHeader\n    display: flex\n    flex-direction: column\n    margin-left: -20px\n    margin-right: -20px\n\n  .TabComponents_tabHeader_selector\n      border-bottom: 3px solid black\n      padding: 0 25px\n\n  .TabComponents_content\n    min-height: 450px\n    display: none\n    padding: 0 15px\n\n    &.active\n      display: flex\n      flex-direction: column\n      justify-content: space-between\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
